/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Active_Current_Use_TimeInputs */

const en_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You will continue to have use of the product until the end of the current billing period.`)
};

const id_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan terus menggunakan produk ini hingga akhir periode penagihan saat ini.`)
};

const ms_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan terus menggunakan produk ini sehingga tamat tempoh bil semasa.`)
};

const ca_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuaràs tenint ús del producte fins al final del període de facturació actual.`)
};

const cs_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt budete moci používat až do konce aktuálního fakturačního období.`)
};

const da_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du vil fortsat kunne bruge produktet indtil slutningen af den aktuelle faktureringsperiode.`)
};

const de_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können das Produkt bis zum Ende des aktuellen Abrechnungszeitraums weiterhin nutzen.`)
};

const et_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toodet saate kasutada kuni praeguse arveldusperioodi lõpuni.`)
};

const es_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuarás teniendo uso del producto hasta el final del período de facturación actual.`)
};

const fr_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous conservez votre accès jusqu’à la fin de la période de facturation en cours.`)
};

const hr_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit ćete koristiti proizvod do kraja trenutačnog obračunskog razdoblja.`)
};

const it_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrai continuare a usare il prodotto fino al termine del ciclo di fatturazione corrente.`)
};

const lv_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs varēsiet izmantot produktu līdz pašreizējā norēķinu perioda beigām.`)
};

const lt_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galėsite naudotis produktu iki dabartinio mokėjimo laikotarpio pabaigos.`)
};

const hu_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az aktuális számlázási időszak végéig tovább használhatja a terméket.`)
};

const nl_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt het product blijven gebruiken tot het einde van de huidige factureringsperiode.`)
};

const nb_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har tilgang til abonnementet frem til slutten av den inneværende betalingsperioden.`)
};

const pl_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Będziesz mieć możliwość korzystania z produktu do końca bieżącego okresu rozliczeniowego.`)
};

const pt_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você continuará a usar o produto até o fim do período de faturamento atual.`)
};

const ro_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veți continua să utilizați produsul până la sfârșitul perioadei de facturare curente.`)
};

const sk_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt budete môcť používať až do konca aktuálneho fakturačného obdobia.`)
};

const sl_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Še naprej boste lahko uporabljali izdelek do konca trenutnega obračunskega obdobja.`)
};

const fi_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voit jatkaa tuotteen käyttöä nykyisen laskutuskauden loppuun saakka.`)
};

const sv_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kommer att kunna använda produkten till slutet av den nuvarande faktureringsperioden.`)
};

const vi_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn sẽ tiếp tục sử dụng sản phẩm cho đến khi kỳ thanh toán hiện tại kết thúc.`)
};

const tr_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürünü mevcut fatura dönemi sonuna kadar kullanmaya devam edeceksiniz.`)
};

const el_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θα συνεχίσετε να χρησιμοποιείτε το προϊόν έως το τέλος της τρέχουσας περιόδου χρέωσης.`)
};

const bg_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ще продължите да използвате продукта до края на текущия биллингов период.`)
};

const ru_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы сможете пользоваться продуктом до конца текущего расчетного периода.`)
};

const sr_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наставићете да користите производ до краја тренутног обрачунског периода.`)
};

const uk_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви зможете використовувати продукт до кінця поточного платіжного періоду.`)
};

const ka_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენ შეგიძლიათ გამოიყენოთ პროდუქტი ამჟამინდელი საგადასახადო პერიოდის დასრულებამდე.`)
};

const hi_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप वर्तमान बिलिंग अवधि के अंत तक उत्पाद का उपयोग जारी रखेंगे।`)
};

const th_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณจะสามารถใช้ผลิตภัณฑ์จนกว่าจะสิ้นสุดรอบบิลปัจจุบัน`)
};

const ko_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 청구 기간이 끝날 때까지 제품을 계속 사용할 수 있습니다.`)
};

const zh_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在当前计费周期结束前，您仍然可以使用该产品。`)
};

const zh_tw_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您將可繼續使用該產品直至當前計費週期結束。`)
};

const ja_active_current_use_time = /** @type {(inputs: Active_Current_Use_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の請求期間が終了するまで製品を使用し続けることができます。`)
};

/**
* | output |
* | --- |
* | "You will continue to have use of the product until the end of the current billing period." |
*
* @param {Active_Current_Use_TimeInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const active_current_use_time = /** @type {((inputs?: Active_Current_Use_TimeInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Active_Current_Use_TimeInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_active_current_use_time(inputs)
	if (locale === "ms") return ms_active_current_use_time(inputs)
	if (locale === "ca") return ca_active_current_use_time(inputs)
	if (locale === "cs") return cs_active_current_use_time(inputs)
	if (locale === "da") return da_active_current_use_time(inputs)
	if (locale === "de") return de_active_current_use_time(inputs)
	if (locale === "et") return et_active_current_use_time(inputs)
	if (locale === "es") return es_active_current_use_time(inputs)
	if (locale === "fr") return fr_active_current_use_time(inputs)
	if (locale === "hr") return hr_active_current_use_time(inputs)
	if (locale === "it") return it_active_current_use_time(inputs)
	if (locale === "lv") return lv_active_current_use_time(inputs)
	if (locale === "lt") return lt_active_current_use_time(inputs)
	if (locale === "hu") return hu_active_current_use_time(inputs)
	if (locale === "nl") return nl_active_current_use_time(inputs)
	if (locale === "nb") return nb_active_current_use_time(inputs)
	if (locale === "pl") return pl_active_current_use_time(inputs)
	if (locale === "pt") return pt_active_current_use_time(inputs)
	if (locale === "ro") return ro_active_current_use_time(inputs)
	if (locale === "sk") return sk_active_current_use_time(inputs)
	if (locale === "sl") return sl_active_current_use_time(inputs)
	if (locale === "fi") return fi_active_current_use_time(inputs)
	if (locale === "sv") return sv_active_current_use_time(inputs)
	if (locale === "vi") return vi_active_current_use_time(inputs)
	if (locale === "tr") return tr_active_current_use_time(inputs)
	if (locale === "el") return el_active_current_use_time(inputs)
	if (locale === "bg") return bg_active_current_use_time(inputs)
	if (locale === "ru") return ru_active_current_use_time(inputs)
	if (locale === "sr") return sr_active_current_use_time(inputs)
	if (locale === "uk") return uk_active_current_use_time(inputs)
	if (locale === "ka") return ka_active_current_use_time(inputs)
	if (locale === "hi") return hi_active_current_use_time(inputs)
	if (locale === "th") return th_active_current_use_time(inputs)
	if (locale === "ko") return ko_active_current_use_time(inputs)
	if (locale === "zh") return zh_active_current_use_time(inputs)
	if (locale === "zh-tw") return zh_tw_active_current_use_time(inputs)
	if (locale === "ja") return ja_active_current_use_time(inputs)
	return en_active_current_use_time(inputs)
});